
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/quickEdit/components/styles/buttonDesignEntryPoint.scss.css.virtualfile';
        module.exports = {"buttonDesignEntryPoint":"_buttonDesignEntryPoint_1juf4_7","link":"_link_1juf4_10"};